import { useTranslation } from "react-i18next";
import OperationInfoItem from "../OffOperationInfo/OperationInfoItem";
import ExpendStatBadge from "../ExpendStatBadge";
import { format$Price, formatPrice } from "utils/helpers/functions/formatPrice";
import { withLocalCurrency } from "utils/helpers/currency/currencyHelpers";
import { DateTime as DT } from "luxon";
import { UserNameItem } from 'modules/user';
import vconst from "utils/helpers/structs/vconst";
 
const ExpendInfo = ({expend}) =>{ 

    const { t } = useTranslation(['Objects']);
    const dt = DT.fromMillis(expend?.expend?.dt||0).toLocaleString(DT.DATETIME_FULL)
    const dtCancel = DT.fromMillis(expend?.expend?.dtCancel||0).toLocaleString(DT.DATETIME_FULL)

    return (<>
        <OperationInfoItem
            title={t('fieldsService.expendType')}
            infoJsx={(<>
                <ExpendStatBadge    
                    expendStatus={expend.expend.expendStatus}/>
            </>)}>
            <div className="d-flex justify-content-between">
                <h6 className="mb-1 text-break">{expend?.expend?.expendName}</h6>
                <div> 
                    {expend?.expend?.expendStatus === vconst.incomeStatCancel 
                    ?(<h6 className="mb-1 text-end text-muted">{format$Price(expend?.expend?.expendAmount)}</h6>)
                    :(<h6 className={`mb-1 text-end ${expend?.expend?.expendAmount>0 ? 'text-success' : 'text-danger'}`}>{format$Price(expend?.expend?.expendAmount, true)}</h6>)}
                    
                    <p className="f-12 mb-0 text-truncate text-muted text-end">{withLocalCurrency(formatPrice(Math.abs(expend?.expend?.expendAmountRate)))}</p> 
                </div>
            </div>
        </OperationInfoItem>
 
        {expend?.expend?.expendDescription && 
        (<OperationInfoItem
            title={t('addService.labelDescription')}>
            <div className="d-flex justify-content-between">
                <div className="text-break" style={{ whiteSpace: 'pre-wrap' }}>{expend?.expend?.expendDescription}</div>
            </div>
        </OperationInfoItem>)}

        <OperationInfoItem
            title={t('fieldsService.ownerApproved')}
            infoText={dt}>
            <UserNameItem user={expend?.expend}/>
        </OperationInfoItem>

        {expend.expend.expendStatus !== vconst .incomeStatActive && 
        (<OperationInfoItem
            title={t('fieldsService.ownerCancel')}
            bg='bg-light-danger'
            infoText={dtCancel}>
            <UserNameItem user={expend?.userCancel}/>
        </OperationInfoItem>)}
    </>)
}

export default ExpendInfo;